import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";

export function ChangeRequestPartBeforeView() {
  return (
    <NodeViewWrapper
      data-change-request-part="before"
      className="relative z-10 text-red-950 decoration-[1.5px] dark:text-red-100 [&_:is(p,h1,h2,h3,h4,h5,h6,blockquote,pre,li)]:line-through"
    >
      <NodeViewContent />
    </NodeViewWrapper>
  );
}
